function setupLeasingButton() {
  const leasingButton = document.querySelector(".leasing-atc-button");
  const checkoutButton = document.querySelector('button[name="checkout"]');

  if (leasingButton) {
    leasingButton.addEventListener("click", async function (event) {
      event.preventDefault();

      try {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            attributes: {
              leasing: true,
            },
          }),
        });

        await response.json();
        await new Promise((resolve) => setTimeout(resolve, 250));
        window.location.href = "/checkout";
      } catch (error) {
        return;
      }
    });
  }

  if (checkoutButton) {
    checkoutButton.addEventListener("click", async function (event) {
      event.preventDefault();

      try {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            attributes: {
              leasing: false,
            },
          }),
        });

        await response.json();
        await new Promise((resolve) => setTimeout(resolve, 250));
        window.location.href = "/checkout";
      } catch (error) {
        return;
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", setupLeasingButton);
document.addEventListener("on:cart-drawer:before-open", setupLeasingButton);
